export const SELECT_SUBSCRIPTION = 'PAYMENT/SELECT_SUBSCRIPTION';
export const SET_CODE = 'PAYMENT/SET_CODE';
export const SET_INVITE_ID = 'PAYMENT/SET_INVITE_ID';

export interface PaymentDispatchTypes {
  type: string;
  payload?: any;
}